import Menu from 'mmenu-js'

const menuElement = document.querySelector('.js-mobile-menu')
const menuTriggerElement = document.querySelectorAll('.js-mobile-menu-trigger')
const menuCloseElement = menuElement.querySelector('.js-mobile-menu-close')
const menuBottomContent = getContentBySelector('[data-bottom-mmenu]')

if (menuElement && menuTriggerElement && window.innerWidth < 768) {
  const menu = new Menu(menuElement, {
    slidingSubmenus: true,
    offCanvas: {
      position: 'left-front'
    },
    navbar: {
      title: 'Меню',
    },
    navbars: [
      {
        'position': 'bottom',
        'content': [menuBottomContent]
      },
    ]
  })
  menuCloseElement.addEventListener('click', () => menu.close())
  menuTriggerElement.forEach(button => button.addEventListener('click', () => menu.open()))
}

function getContentBySelector(name) {
  return document.querySelector(name).content.cloneNode(true);
}